
import axios from "axios";

const HTTP_TIMEOUT = 0;
const HTTP_OTHER_TIMEOUT = 0;

export const http = axios.create({
	baseURL:  `${process.env.REACT_APP_BACKEND}`,
	timeout: HTTP_TIMEOUT,
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
		'Referrer-Policy': 'strict-origin-when-cross-origin',
		
	},
});



export const httpLogin = axios.create({
	baseURL:  `${process.env.REACT_APP_BACKEND_LOGIN}`,
	timeout: HTTP_OTHER_TIMEOUT,
	headers: {
	  Accept: "application/json",
	  "Content-Type": "application/json",
	  "Access-Control-Allow-Origin": "*",
	  "X-Requested-With": "XMLHttpRequest",
	},
  });

  let token ;
  let newsLetterToken
	if (typeof window !== 'undefined') {
	  token = localStorage.getItem('token');
	  newsLetterToken = localStorage.getItem('newsLetterToken');
  
  } 
	   
 
	 
	
	export const httpWithNewsLetterToken = (token?: string)=>axios.create({
	  baseURL: process.env.REACT_APP_BACKEND,
	  timeout: HTTP_OTHER_TIMEOUT,
	  headers: {
		Accept: 'application/json',
		'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
		Authorization: `Bearer ${token}`,
	  },
	});



	
	export const httpwithtoken = axios.create({
	  baseURL: process.env.REACT_APP_BACKEND,
	  timeout: HTTP_OTHER_TIMEOUT,
	  headers: {
		Accept: 'application/json',
		'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
		Authorization: `Bearer ${token}`,
	  },
	});
 
